// extracted by mini-css-extract-plugin
export var button = "styles-module--button--d1c6f";
export var c2aBox = "styles-module--c2aBox--8c7be";
export var h1Serif = "styles-module--h1Serif--92e35";
export var highlight = "styles-module--highlight--e0d2c";
export var homeTeaser = "styles-module--homeTeaser--823c9";
export var subtitle = "styles-module--subtitle--dd923";
export var title = "styles-module--title--ff0d5";